<script setup>
/* eslint-disable */
import { onMounted, onUnmounted, watch, ref } from 'vue';
import { useSocketStore } from '@/stores/socket';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useLiveSportsStore } from '@/stores/live_sports';
import { useLiveSportOverview } from '@/stores/live_sport_overview';
import { useMarketsStore } from '@/stores/markets';
import { useGeneralStore } from '@/stores/general';
import { useRouter, useRoute } from 'vue-router';
import { useSportPopularStore } from '@/stores/sport_popular';
import EsportSlider from '@/components/esports/EsportSlider.vue';
import EsportFeaturedFixtures from '@/components/esports/EsportFeaturedFixtures.vue';
import LiveOverview from '@/components/esports/highlights/LiveOverview.vue';
import UpcomingOverview from '@/components/esports/highlights/UpcomingOverview.vue';
import PopularOverview from '@/components/esports/highlights/PopularOverview.vue';
import { useI18n } from 'vue-i18n';

const socketStore = useSocketStore();
const preSportsStore = usePreSportsStore();
const liveSportsStore = useLiveSportsStore();
const marketsStore = useMarketsStore();
const liveSportOverviewStore = useLiveSportOverview();
const generalStore = useGeneralStore();
const sportPopularStore = useSportPopularStore();

const router = useRouter();
const route = useRoute();

const { t } = useI18n();

const active_tab = ref('upcoming');
const competitions_closed = ref(false);
const show_scroll_to_top_button = ref(false);

const show_primary_overview_market = ref(false);
const show_secondary_overview_market = ref(false);

const primary_overview_market = ref(null);
const secondary_overview_market = ref(null);

const changeTab = (tab) => {
	active_tab.value = tab;
}

const selectPrimaryOverviewMarket = (overview_market) => {
	primary_overview_market.value = overview_market;
	show_primary_overview_market.value = false;
}

const selectSecondaryOverviewMarket = (overview_market) => {
	secondary_overview_market.value = overview_market;
	show_secondary_overview_market.value = false;
}

const closePrimaryOverviewMarketSelector = () => {
	show_primary_overview_market.value = false;
}

const closeSecondaryOverviewMarketSelector = () => {
	show_secondary_overview_market.value = false;
}


const handleScroll = () => {
	const scrollTop = window.scrollY;
	show_scroll_to_top_button.value = scrollTop > 100;
};
const scrollToTop = () => {
	const container = document.querySelector('.live-tab-info');
	window.scrollTo({ top: 0 });
};
onMounted(() => {
	if (router.currentRoute.value.params.sport_id != '' && router.currentRoute.value.params.sport_id != 'all') {
		let selected_esport = _.find(preSportsStore.esports, {'id': Number(router.currentRoute.value.params.sport_id) });
		if (selected_esport) document.title = generalStore.getGeneral.site_name + ' - ' + selected_esport.name + ' ' + t('general.highlights');

		let sport_overview_markets = marketsStore.sportOverviewMarkets(router.currentRoute.value.params.sport_id);

		if (sport_overview_markets?.length > 0) {
			if (sport_overview_markets.length > 1) {
				primary_overview_market.value = sport_overview_markets[0];
				secondary_overview_market.value = sport_overview_markets[1];
			} else {
				primary_overview_market.value = sport_overview_markets[0];
				secondary_overview_market.value = sport_overview_markets[0]
			}
		}

		preSportsStore.setSelectedEsportId(router.currentRoute.value.params.sport_id);
    	preSportsStore.setSelectedPreSportId(router.currentRoute.value.params.sport_id);

		socketStore.join('sportHighlights', router.currentRoute.value.params.sport_id);
		socketStore.join('liveSportOverview', router.currentRoute.value.params.sport_id);
		window.addEventListener('scroll', handleScroll);
	}
})

onUnmounted( () => {
	socketStore.leave('sportHighlights', preSportsStore.selectedEsportId);
	socketStore.leave('liveSportOverview');
	liveSportOverviewStore.emptyLiveSportsOverview();
})

watch(() => preSportsStore.esports, (newSports, oldSports) => {
	if (oldSports.length == 0 && newSports.length > 0) {
		let selected_esport = _.find(preSportsStore.esports, {'id': Number(router.currentRoute.value.params.sport_id) });
		if (!selected_esport) return;
		document.title = generalStore.getGeneral.site_name + ' - ' + selected_esport.name + ' ' + t('general.highlights');
	}
})

watch(route, (to, from) => {
	if (!to.params.hasOwnProperty('sport_id') || to.params.sport_id == '' || to.params.sport_id == 'all') return;

	socketStore.join('sportHighlights', to.params.sport_id);
	socketStore.join('liveSportOverview', to.params.sport_id);

	let sport_overview_markets = marketsStore.sportOverviewMarkets(router.currentRoute.value.params.sport_id);
	if (sport_overview_markets.length > 1) {
		primary_overview_market.value = sport_overview_markets[0];

		secondary_overview_market.value = sport_overview_markets[1]
	} else {
		primary_overview_market.value = sport_overview_markets[0];
		secondary_overview_market.value = sport_overview_markets[0]
	}

	let selected_esport = _.find(preSportsStore.esports, {'id': Number(router.currentRoute.value.params.sport_id) });
	document.title = generalStore.getGeneral.site_name + ' - ' + selected_esport.name + ' ' + t('general.highlights');

});

</script>

<template>

	<div class="live-bet-dashboard round-games-main">
		<div class="bet-dashboard-top">

			<div class="dashboard-info-label">
				<div class="sport-title">
				<img :src="preSportsStore.selectedPreSportIcon" alt="Selected Sport Icon">
				<h6>{{ preSportsStore.selectedPreSportName }}</h6>
				</div>
			</div>
				<span class="toggle-markets">
					<div @click="competitions_closed = !competitions_closed" class="markets-toggle-fill">
						<svg v-if="!competitions_closed" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="markets-toggle-svg">
							<use xlink:href="/assets/icons/markets_close.svg#markets_close"></use>
						</svg>
						<svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="markets-toggle-svg">
							<use xlink:href="/assets/icons/markets_open.svg#markets_open"></use>
						</svg>
						</div>
				</span>
		</div>

		<div class="live-tab-info" id="tabs">
			<UpcomingOverview
        v-model:competitions_closed="competitions_closed"
        :competition="competition"
        :primary_overview_market="primary_overview_market"
        :secondary_overview_market="secondary_overview_market"
      />
		</div>
	</div>
	<button @click="scrollToTop" type="button" class="btn scroll-to-top" id="btn-back-to-top" v-show="show_scroll_to_top_button">
		<i class="fas fa-arrow-up"></i>
	</button>
</template>
<style scoped>
@media screen and (min-width: 768px) and (max-width: 991px) {
	.live-bet-dashboard .live-tab-info {
		max-height: unset;
	}
}
@media screen and (min-width: 992px) and (max-width: 3000px) {
	button#btn-back-to-top {
		display:none;
	}
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	button#btn-back-to-top {
		bottom: 95px;
		left: 20px;
	}
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	svg.svg-inline--fa.fa-arrow-up.fa-w-14 {
		margin-bottom: 7px!important;
	}
	button#btn-back-to-top {
		width: 30px!important;
		height: 30px!important;
		font-size: 14px!important;
	}
}
button#btn-back-to-top {
	background: var(--primary);
	width: 38px;
	height: 38px;
	border: none;
	border-radius: 50%;
	position: fixed;
	z-index: 99;
	box-shadow: 0 2px 4px var(--list-gray);
	font-size: 16px;
	cursor: pointer;
}
html[dir="rtl"] button#btn-back-to-top {
	left: unset;
	right:20px;
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	button#btn-back-to-top {
		left: 10px;
	}
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	html[dir="rtl"] button#btn-back-to-top {
		left: unset;
		right:10px;
	}
}
.live-bet-dashboard.round-games-main .bet-dashboard-top:after {
	width: 100% !important;
}
@media screen and (min-width: 768px) {
	.tab-pills {
		padding-bottom: 12px;
	}
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	.dropdown-option-top-2 {
		display: none;
	}
}
@media screen and (min-width: 320px) and (max-width: 323px) {
	.last-btn {
		margin-top: 5px;
	}
}

html[dir="rtl"] .live-bet-dashboard .bet-dashboard-top:after {
	right: unset;
	left: 0px;
}

</style>